@if (rendering && solarPanelsOrderFormViewModel$ | async; as vm) {
  <wl-solar-panels-order-form
    trackImpression="contentblock-impression"
    [trackImpressionInfo]="rendering"
    [trackToolConfig]="trackToolConfig"
    [solarPanelsOrderFormViewModel]="vm"
    [rendering]="rendering"
  ></wl-solar-panels-order-form>
}
